module.exports = __webpack_public_path__ + "static/img/rage-strike-quests-scaled@2x.9d6ab2e5.png";